module.exports = __webpack_public_path__ + "img/C8D1DC_575B62_818892_6E747B-256px.72f117b7.png";